export type Category = "娱乐" | "社会" | "科技" | "民生" | "文体";

export interface HotItem {
  id: number;
  rank: number;
  title: string;
  heat: string;
  delta: "up" | "down" | "new" | "flat";
  category: Category;
  discuss: number;
}

export interface NewsItem {
  id: number;
  category: Category;
  title: string;
  excerpt: string;
  time: string;
  hot: number;
  image: string;
}

export interface DebateItem {
  id: number;
  title: string;
  voters: number;
  takeA: string;
  takeB: string;
  rateA: number;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const hotList: HotItem[] = [
  { id: 1, rank: 1, title: "#新剧大结局登顶 全网蹲守最后一集#", heat: "982.6万", delta: "up", category: "娱乐", discuss: 12.4 },
  { id: 2, rank: 2, title: "#顶流演唱会官宣 抢票通道挤爆#", heat: "915.3万", delta: "new", category: "娱乐", discuss: 11.2 },
  { id: 3, rank: 3, title: "#暴雨红色预警 多城启动应急响应#", heat: "864.1万", delta: "up", category: "社会", discuss: 9.8 },
  { id: 4, rank: 4, title: "#AI眼镜新品刷屏 网友排队体验#", heat: "781.5万", delta: "up", category: "科技", discuss: 8.6 },
  { id: 5, rank: 5, title: "#中秋档电影预售开启 竞争白热化#", heat: "720.4万", delta: "flat", category: "文体", discuss: 7.3 },
  { id: 6, rank: 6, title: "#市民反映小区充电桩不足 官方回应#", heat: "668.2万", delta: "up", category: "民生", discuss: 6.5 },
  { id: 7, rank: 7, title: "#新综艺开播即黑马 口碑持续走高#", heat: "612.7万", delta: "up", category: "娱乐", discuss: 6.1 },
  { id: 8, rank: 8, title: "#国货彩妆联名款上线 一秒售罄#", heat: "559.3万", delta: "new", category: "民生", discuss: 5.4 },
  { id: 9, rank: 9, title: "#高校食堂上新菜系 学生直呼真香#", heat: "501.8万", delta: "down", category: "社会", discuss: 4.9 },
  { id: 10, rank: 10, title: "#国产大模型再升级 编程能力引热议#", heat: "455.2万", delta: "up", category: "科技", discuss: 4.2 },
];

export const newsFeed: NewsItem[] = [
  {
    id: 1,
    category: "娱乐",
    title: "新剧《浮光掠影》大结局播出，双平台观看人次破亿，网友为结局走向吵翻天",
    excerpt: "今晚大结局上线后，剧集相关话题接连冲上热搜。主创直播回应争议，导演透露原定结局有三个版本，最终版本引发全网二创热潮。",
    time: "刚刚",
    hot: 98,
    image: "https://readdy.ai/api/search-image?query=cinematic%20night%20city%20street%20with%20neon%20lights%20and%20silhouette%20of%20actors%20under%20warm%20street%20lamps%2C%20drama%20film%20poster%20style%2C%20soft%20focus&width=720&height=480&seq=news-drama-01&orientation=landscape",
  },
  {
    id: 2,
    category: "科技",
    title: "新一代 AI 眼镜正式发布，轻量镜身加实时翻译，体验区排起长队",
    excerpt: "发布会现场演示了同传翻译与语音助手功能，产品重量与普通眼镜相当。不少数码博主第一时间上手体验，称“比想象中实用”。",
    time: "8 分钟前",
    hot: 92,
    image: "https://readdy.ai/api/search-image?query=sleek%20smart%20glasses%20product%20on%20minimal%20display%20with%20translucent%20holographic%20interface%20and%20soft%20studio%20lighting%2C%20tech%20product%20photography&width=720&height=480&seq=news-ai-02&orientation=landscape",
  },
  {
    id: 3,
    category: "社会",
    title: "南方多地遭遇强降雨，地铁加开区间车，志愿者连夜值守一线",
    excerpt: "受短时强对流影响，多座城市出现积水。相关部门第一时间发布预警，交管部门对重点路段疏导，社区志愿者冒雨排险。",
    time: "22 分钟前",
    hot: 87,
    image: "https://readdy.ai/api/search-image?query=city%20street%20during%20heavy%20rain%20with%20reflective%20puddles%20and%20umbrellas%2C%20soft%20warm%20and%20blue%20tones%2C%20photojournalism%20style&width=720&height=480&seq=news-rain-03&orientation=landscape",
  },
  {
    id: 4,
    category: "民生",
    title: "充电桩进小区难上热搜，多部门表态：将推动统建统管新模式",
    excerpt: "针对网友反映的新能源充电痛点，主管部门回应正在试点“统建统管”模式，计划年内覆盖更多小区，缓解居民充电难。",
    time: "36 分钟前",
    hot: 81,
    image: "https://readdy.ai/api/search-image?query=electric%20car%20charging%20at%20a%20residential%20community%20station%20in%20the%20morning%2C%20clean%20urban%20setting%2C%20natural%20light&width=720&height=480&seq=news-charge-04&orientation=landscape",
  },
  {
    id: 5,
    category: "文体",
    title: "中秋档票房预售战打响，多部新片扎堆，机构预计档期总票房创新高",
    excerpt: "多部类型各异的影片同日开启预售，喜剧、动画与悬疑各有拥趸。业内人士预测，今年中秋档有望成为近年最强档期之一。",
    time: "1 小时前",
    hot: 74,
    image: "https://readdy.ai/api/search-image?query=warm%20mid%20autumn%20moon%20festival%20cinema%20poster%20collage%20with%20film%20reels%20popcorn%20and%20paper%20lanterns%20on%20soft%20background&width=720&height=480&seq=news-film-05&orientation=landscape",
  },
  {
    id: 6,
    category: "娱乐",
    title: "新音综《声浪制造机》首播即爆，导师即兴舞台被刷上热搜",
    excerpt: "节目首期播出后讨论度飙升，舞台设计被赞“审美在线”。节目组回应第二期飞行嘉宾将带来更多跨界舞台。",
    time: "1.4 小时前",
    hot: 68,
    image: "https://readdy.ai/api/search-image?query=vibrant%20music%20variety%20show%20stage%20with%20colorful%20spotlights%20and%20microphone%20stand%20silhouette%2C%20live%20performance%20energy&width=720&height=480&seq=news-music-06&orientation=landscape",
  },
  {
    id: 7,
    category: "科技",
    title: "国产大模型更新到新一代版本，复杂编程与长文本能力大幅提升",
    excerpt: "新版本在代码生成、逻辑推理与上下文理解上均有突破，开发者社区反响热烈。官方同步开放了更多免费调用额度。",
    time: "2 小时前",
    hot: 63,
    image: "https://readdy.ai/api/search-image?query=abstract%20digital%20neural%20network%20visualization%20with%20flowing%20lines%20and%20nodes%2C%20deep%20teal%20and%20warm%20amber%20on%20dark%20background&width=720&height=480&seq=news-llm-07&orientation=landscape",
  },
  {
    id: 8,
    category: "民生",
    title: "国货美妆联名中秋限定上线，礼盒秒空，二手平台价格水涨船高",
    excerpt: "联名款以古典纹样为主题，上线不到半小时即告售罄。品牌方回应将追加备货，同时提醒消费者理性按需购买。",
    time: "2.6 小时前",
    hot: 57,
    image: "https://readdy.ai/api/search-image?query=elegant%20limited%20edition%20cosmetics%20gift%20box%20with%20chinese%20classical%20pattern%20and%20ribbon%2C%20studio%20product%20photography%2C%20warm%20soft%20light&width=720&height=480&seq=news-beauty-08&orientation=landscape",
  },
];

export const categories: Category[] = ["娱乐", "社会", "科技", "民生", "文体"];

export const debateList: DebateItem[] = [
  {
    id: 1,
    title: "剧集结局的开放式收尾，到底是高级还是烂尾？",
    voters: 32,
    takeA: "留白更有回味",
    takeB: "想要明确交代",
    rateA: 58,
  },
  {
    id: 2,
    title: "抢票靠手速还是该学机场放号？演唱会购票该不该预约制？",
    voters: 27,
    takeA: "实名预约更公平",
    takeB: "手速体现诚意",
    rateA: 64,
  },
  {
    id: 3,
    title: "AI 越来越能写，创作者该焦虑还是借力？",
    voters: 24,
    takeA: "工具就该为我所用",
    takeB: "原创不可替代",
    rateA: 71,
  },
];

export const faqs: FaqItem[] = [
  {
    q: "「今日新瓜」多久更新一次？",
    a: "吃瓜最新实时抓取并人工审核当天热点，热门事件发生后通常几分钟内即可上架到「今日新瓜」榜单。",
  },
  {
    q: "热搜榜上的热度是怎么来的？",
    a: "热搜榜综合了搜索热度、讨论量与传播速度，热度越高代表当前关注的人越多、讨论越集中。",
  },
  {
    q: "站内的瓜点信息真实可靠吗？",
    a: "内容以公开可查的事件动态为主，并结合多方信源交叉核对，尽量还原事实本身，不做主观定性。",
  },
  {
    q: "我如何提交一个刚发生的劲爆消息？",
    a: "你可以通过页面底部或「关于本站」中提供的编辑部邮箱投稿，经核实后会优先收录到最新爆料区。",
  },
];